import { useWindowDimensions } from "@/components/hooks/use-window-dimension";
import { Divider } from "@/components/shared/divider";
import { useRoute } from "@/components/shared/router";
import { Typography } from "@/components/shared/typography";
import { View } from "@/components/ui";
import { IconButton } from "@/components/ui/icon-button";

import { ShareGiftCardModalProvider } from "../share-gift-card-modal";
import { GiftCardHero } from "./section-hero";
import { GiftCardHistory } from "./section-history";
import { GiftCardHowItWorks } from "./section-how-it-works";
import { GiftCardOccasion } from "./section-occasion";

export const AccountGiftCard = () => {
  const { push } = useRoute();
  const { isMobile } = useWindowDimensions();

  return (
    <ShareGiftCardModalProvider>
      <View className="pb-safe flex flex-col">
        <View className="web:border-b static flex flex-row items-start justify-between md:mb-8 md:pb-4">
          <View className="native:hidden flex flex-row items-center gap-2 p-4 md:p-0">
            <IconButton
              variant={isMobile ? "ghost" : "secondary"}
              color="foreground"
              iconName="arrowLeft"
              rounded="full"
              className="p-0 md:px-3 md:py-2"
              onClick={() => push({ pageKey: "accountInfo" })}
            />
            <Typography variant="label-md">Gift Card</Typography>
          </View>
        </View>
        <GiftCardHero />
        <View className="border-border-medium my-3 rounded-xl md:border">
          <GiftCardOccasion />
          <Divider className="h-0.5" />
          <GiftCardHistory />
          <Divider className="h-0.5" />
          <GiftCardHowItWorks />
        </View>
      </View>
    </ShareGiftCardModalProvider>
  );
};
